<template>
  <div class="pages-cabinpro-samples-detail-basic content-container" id="pages-cabinpro-samples-detail-basic">
    <div class="container-scroll">
      <section class="layout-pad-full layout-margin-bottom back-white">
        <a-breadcrumb>
          <a-breadcrumb-item>首页</a-breadcrumb-item>
          <a-breadcrumb-item>生活中心</a-breadcrumb-item>
          <a-breadcrumb-item>开具发票</a-breadcrumb-item>
        </a-breadcrumb>
      </section>
      <section class="layout-pad-full layout-pad-top-nil back-white">
        <h1 class="holder-title">发票信息</h1>
        <d-alert
          message="kai ju"
          description="Detailed description and advices about successful copywriting."
          type="success"
          show-icon
        />
        <a-table :pagination="false" :data-source="defaultValue.list" :columns="tableObj.columns"></a-table>
      </section>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import NP from 'number-precision'
import ajax from '../../lib/axios/ajax'
import { INVOICE_QUERYINVOICEDETAILLIST } from '../../lib/axios/apilist'

export default {
//这里必须 使用一个方法返回给data
  data: function () {
    let defaultValue = {
      invoiceOrderNo: undefined, // 发票订单号
      sgInvoiceId: undefined, // 四格发票id
      custId: undefined, // 客户编号
      custName: undefined, // 客户名称称
      contrantId: undefined, // 合同号
      mchNo: undefined, // 门门店编号
      mchName: undefined, // 门店名称
      invoiceType: undefined, // 发票种类  普票 专票
      invoiceAmount: undefined, // 发票金额（含税）
      invoiceTaxAmount: undefined, // 发票税额
      invoiceItem: undefined, // 发票项目
      invoiceDate: undefined, // 开票日期
      custTaxNo: undefined, // 客户税号
      custAdress: undefined, // 客户地址
      custCompanyName: undefined, // 客户公司名称
      custPhone: undefined, // 客户手机号
      merBankNo: undefined, // 客户银行账户
      merOpenBank: undefined, // 客户银行开户行
      invoiceCode: undefined, // 发票代码
      invoiceNo: undefined, // 发票号码
      sellerName: undefined, // 销方名称
      invoiceUrl: undefined, // 发票下载地址url
      invoiceStatus: undefined, // 发票状态
      approvalType: undefined, // 审批类型
      approvalStatus: undefined, // 审批状态
      redChancelFlag: undefined, // 红冲标识
      incomeStatus: undefined, // 收入状态 0 已收款 1未收款
      invoiceTypeName: undefined, // 发票种类  普票 专票
      approvalTypeName: undefined, // 审批类型名称   红冲审批   未确认审批
      approvalStatusName: undefined, // 审批状态名称
      list: []
    }
    let tableObj = {
      tableLoading: false,
      selectedRowKeys: [],
      list: [],
      scroll: {
        x: 1000,
      },
      columns: [
        { title: '账单ID', dataIndex: 'billId' }, 
        { title: '资源类型', dataIndex: 'resourceTypeName' }, 
        { title: '资源名称', dataIndex: 'resourceName' }, 
        { title: '本金', dataIndex: 'projectAmount' }, 
        { title: '本金税率', dataIndex: 'taxzRate' }, 
        { title: '四格项目名称', dataIndex: 'invoiceItem' }, 
        { title: '物美项目名称', dataIndex: 'wmItemName' }, 
        { title: '收入状态', dataIndex: 'incomeStatusName' }, 
        { title: '应收账期', dataIndex: 'deliveryTime' }, 
        { title: '费用开始时间', dataIndex: 'starBillTime' }, 
        { title: '费用结束时间', dataIndex: 'endBillTime' }, 
        { title: '违约金', dataIndex: 'penalAmount' }, 
        { title: '违约金税率', dataIndex: 'lfreeTaxRate' }, 
        { title: '违约金税额', dataIndex: 'lfreeTaxFee' }, 
      ],
    }
    return {
      defaultValue,
      tableObj,
    }
  },
  beforeCreate () {
  },
  mounted() {
    this.$nextTick(function () {
      
    });
    this.detail()
    
  },
  beforeDestroy: function () {
    
  },
  destroyed: function () {
    
  },
  watch: {
  },
  computed: {
  },
  methods: {
    detail() {
      let requestParam = {
        invoiceOrderNo: this.$route.query.invoiceOrderNo
      }
      
      let successFunc = (res) => {
        // 关闭加载效果
        if (res.code === "0000") {
          this.defaultValue = res.data
        } else {
          this.$error({
            title: '提示',
            content: res.result,
          });
        }
      };
      let errorFunc = (res) => {
        this.tableObj.tableLoading = false;
        this.$error({
          title: '提示',
          content: res.result,
        });
      };

      //搜索地址
      let url = INVOICE_QUERYINVOICEDETAILLIST;
      ajax.fetch(url, requestParam, successFunc, errorFunc)

    },
  }
}
</script>